<div class="flex justify-between px-6 pt-8">
    <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Report this post</p>
    <img
        src="/assets/images/shared/cross-black-icon.svg"
        alt="Close Icon"
        class="h-4 w-auto cursor-pointer"
        (click)="onCancel()" />
</div>

<mat-dialog-content class="space-y-1">
    <form class="space-y-4" [formGroup]="reportForm" (ngSubmit)="submit()">
        <p class="text-[#717182] text-[0.875rem]">What's wrong with your post?</p>
        <div class="flex flex-col space-y-3 py-4 text-[#0A0A0A] font-medium">
            <label class="flex items-center space-x-2">
                <input
                    type="radio"
                    class="accent-[#4F66FF]"
                    formControlName="reason"
                    [value]="getReportTypeLabel(ReportTypeEnum.RudeVulgar)" />
                <span>{{ getReportTypeLabel(ReportTypeEnum.RudeVulgar) }}</span>
            </label>
            <label class="flex items-center space-x-2">
                <input
                    type="radio"
                    class="accent-[#4F66FF]"
                    formControlName="reason"
                    [value]="getReportTypeLabel(ReportTypeEnum.FalseInformation)" />
                <span>{{ getReportTypeLabel(ReportTypeEnum.FalseInformation) }}</span>
            </label>
            <label class="flex items-center space-x-2">
                <input
                    type="radio"
                    class="accent-[#4F66FF]"
                    formControlName="reason"
                    [value]="getReportTypeLabel(ReportTypeEnum.HateSpeech)" />
                <span>{{ getReportTypeLabel(ReportTypeEnum.HateSpeech) }}</span>
            </label>
            <label class="flex items-center space-x-2">
                <input
                    type="radio"
                    class="accent-[#4F66FF]"
                    formControlName="reason"
                    [value]="getReportTypeLabel(ReportTypeEnum.Threatening)" />
                <span>{{ getReportTypeLabel(ReportTypeEnum.Threatening) }}</span>
            </label>
            <label class="flex items-center space-x-2">
                <input
                    type="radio"
                    class="accent-[#4F66FF]"
                    formControlName="reason"
                    [value]="getReportTypeLabel(ReportTypeEnum.SomethingElse)" />
                <span>{{ getReportTypeLabel(ReportTypeEnum.SomethingElse) }}</span>
            </label>
        </div>

        <button type="submit" class="border-button py-4 rounded-2xl w-[81px] ml-auto block">
            <p>Send</p>
        </button>
    </form>
</mat-dialog-content>
